/**
 * Données des parcs pour le menu ParkMenu
 * Séparé du composant pour optimiser le chargement initial
 * Les logos ne seront chargés que lorsque le menu est ouvert
 */

export const getAllParksData = (t) => ({
  europe: [
    // Bellewaerde
    { id: 'bellewaerde', name: t('parks.bellewaerde'), path: '/bellewaerde', logo: '/images/logos/logo-bellewaerde.png' },
    
    // Bobbejaanland
    { id: 'bobbejaanland', name: t('parks.bobbejaanland'), path: '/bobbejaanland', logo: '/images/logos/logo-bobbejaanland.png' },
    
    // Disneyland Paris Resort
    { id: 'dlp', name: t('parks.dlp'), path: '/', logo: '/images/logos/logo-dlp.png' },
    { id: 'wds', name: t('parks.wds'), path: '/studios', logo: '/images/logos/logo-daw.png' },
    
    // Efteling
    { id: 'eft', name: t('parks.eft'), path: '/efteling', logo: '/images/logos/logo-efteling.png' },
    
    // Energylandia
    { id: 'energylandia', name: t('parks.energylandia'), path: '/energylandia', logo: '/images/logos/logo-energylandia.png' },
    
    // Europa Park
    { id: 'ep', name: t('parks.europaPark'), path: '/europa-park', logo: '/images/logos/logo-ep.png' },
    
    // Futuroscope
    { id: 'futuroscope', name: t('parks.futuroscope'), path: '/futuroscope', logo: '/images/logos/logo-futuro.png' },
    
    // Gardaland
    { id: 'gardaland', name: t('parks.gardaland'), path: '/gardaland', logo: '/images/logos/logo-gardaland.png' },
    
    // Gröna Lund
    { id: 'gronaLund', name: t('parks.gronaLund'), path: '/grona-lund', logo: '/images/logos/logo-gronalund.png' },
    
    // Le Pal
    { id: 'lePal', name: t('parks.lePal'), path: '/le-pal', logo: '/images/logos/logo-lepal.png' },
    
    // Mirabilandia
    { id: 'mirabilandia', name: t('parks.mirabilandia'), path: '/mirabilandia', logo: '/images/logos/logo-mirabilandia.png' },
    
    // Movie Park Germany
    { id: 'movieParkGermany', name: t('parks.movieParkGermany'), path: '/movie-park-germany', logo: '/images/logos/logo-movie-park-germany.png' },
    
    // Nigloland
    { id: 'niglo', name: t('parks.nigloland'), path: '/nigloland', logo: '/images/logos/logo-niglo.png' },
    
    // Parc Astérix
    { id: 'ast', name: t('parks.parcAsterix'), path: '/parc-asterix', logo: '/images/logos/logo-asterix.png' },
    
    // Parque de Atracciones de Madrid
    { id: 'parqueDeAtraccionesDeMadrid', name: t('parks.parqueDeAtraccionesDeMadrid'), path: '/parque-de-atracciones-de-madrid', logo: '/images/logos/logo-parque-de-atracciones-de-madrid.png' },
    
    // Phantasialand
    { id: 'pha', name: t('parks.phantasialand'), path: '/phantasialand', logo: '/images/logos/logo-phantasialand.png' },
    
    // Plopsaland De Panne
    { id: 'plopsalandDepanne', name: t('parks.plopsalandDepanne'), path: '/plopsaland-de-panne', logo: '/images/logos/logo-plopsapanne.png' },
    
    // PortAventura Park
    { id: 'portaventura', name: t('parks.portaventura'), path: '/portaventura', logo: '/images/logos/logo-portaventura.png' },
    
    // Thorpe Park
    { id: 'thorpePark', name: t('parks.thorpePark'), path: '/thorpe-park', logo: '/images/logos/logo-thorpepark.png' },
    
    // Toverland
    { id: 'tov', name: t('parks.toverland'), path: '/toverland', logo: '/images/logos/logo-toverland.png' },
    
    // Walibi (groupés par ordre alphabétique)
    { id: 'walibiBelgium', name: t('parks.walibiBelgium'), path: '/walibi-belgium', logo: '/images/logos/logo-walibibelgium.png' },
    { id: 'walibiHolland', name: t('parks.walibiHolland'), path: '/walibi-holland', logo: '/images/logos/logo-walibi-holland.png' },
    { id: 'walibiRhoneAlpes', name: t('parks.walibiRhoneAlpes'), path: '/walibi-rhone-alpes', logo: '/images/logos/logo-walibi-rhone-alpes.png' },
    
    // Alton Towers
    { id: 'altonTowers', name: 'Alton Towers', path: '/alton-towers', logo: '/images/logos/logo-alton-towers.png' },
    
    // Heide Park
    { id: 'heidePark', name: 'Heide Park', path: '/heide-park', logo: '/images/logos/logo-heide-park.png' },
    
    // LEGOLAND Deutschland
    { id: 'legolandDeutschland', name: 'LEGOLAND Deutschland', path: '/legoland-deutschland', logo: '/images/logos/logo-legoland-deutschland.png' }
  ],
  northAmerica: [
    // Busch Gardens Tampa Bay
    { id: 'buschgardens', name: t('parks.buschGardens'), path: '/busch-gardens-tampa', logo: '/images/logos/logo-bushgardentampa.png' },
    
    // Disneyland Resort (Californie)
    { id: 'disneylandCalifornia', name: t('parks.disneylandCalifornia'), path: '/disneyland-california', logo: '/images/logos/logo-disneylandparkca.png' },
    { id: 'disneyCaliforniaAdventure', name: t('parks.disneyCaliforniaAdventure'), path: '/disney-california-adventure', logo: '/images/logos/logo-disneylandcaliforniadventure.png' },
    
    // Knott's Berry Farm
    { id: 'knotts', name: "Knott's Berry Farm", path: '/knotts-berry-farm', logo: '/images/logos/logo-knotts.png' },
    
    // LEGOLAND Florida
    { id: 'legoland', name: t('parks.legolandFlorida'), path: '/legoland-florida', logo: '/images/logos/logo-legolandflorida.png' },
    
    // SeaWorld Orlando
    { id: 'seaworld', name: t('parks.seaWorld'), path: '/seaworld-orlando', logo: '/images/logos/logo-seaworld.png' },
    
    // Universal Orlando Resort
    { id: 'usf', name: t('parks.usf'), path: '/universal-studios', logo: '/images/logos/logo-unistudio.png' },
    { id: 'ioa', name: t('parks.ioa'), path: '/islands-of-adventure', logo: '/images/logos/logo-uniislands.png' },
    { id: 'epu', name: t('parks.epu'), path: '/epic-universe', logo: '/images/logos/logo-epicuniverse.png' },

    // Universal Studios California
    { id: 'universalStudiosCalifornia', name: t('parks.universalStudiosCalifornia'), path: '/universal-studios-california', logo: '/images/logos/logo-universal-studios-hollywood.png' },
    
    // Walt Disney World Resort
    { id: 'magicKingdom', name: t('parks.magicKingdom'), path: '/magic-kingdom', logo: '/images/logos/logo-wdw-magickingdom.png' },
    { id: 'epcot', name: t('parks.epcot'), path: '/epcot', logo: '/images/logos/logo-wdw-epcot.png' },
    { id: 'hollywoodStudios', name: t('parks.hollywoodStudios'), path: '/hollywood-studios', logo: '/images/logos/logo-wdw-hollywoodstudios.png' },
    { id: 'animalKingdom', name: t('parks.animalKingdom'), path: '/animal-kingdom', logo: '/images/logos/logo-wdw-animal-kingdom.png' },
    { id: 'typhoonLagoon', name: t('parks.typhoonLagoon'), path: '/typhoon-lagoon', logo: '/images/logos/logo-wdw-typhoon-lagoon.png' },
    { id: 'blizzardBeach', name: t('parks.blizzardBeach'), path: '/blizzard-beach', logo: '/images/logos/logo-wdw-blizzard-beach.png' },
    
    // Volcano Bay (Universal Orlando)
    { id: 'volcanoBay', name: "Universal's Volcano Bay", path: '/volcano-bay', logo: '/images/logos/logo-volcano-bay.png' },
    
    // Carowinds
    { id: 'carowinds', name: 'Carowinds', path: '/carowinds', logo: '/images/logos/logo-carowinds.png' },
    
    // Hersheypark
    { id: 'hersheypark', name: 'Hersheypark', path: '/hersheypark', logo: '/images/logos/logo-hershey-park.png' },
    
    // Kennywood
    { id: 'kennywood', name: 'Kennywood', path: '/kennywood', logo: '/images/logos/logo-kennywood.png' },
    
    // Kings Island
    { id: 'kingsIsland', name: 'Kings Island', path: '/kings-island', logo: '/images/logos/logo-kings-island.png' },
    
    // Knoebels
    { id: 'knoebels', name: 'Knoebels Amusement Park', path: '/knoebels', logo: '/images/logos/logo-knoebels.png' },
    
    // La Ronde (Canada)
    { id: 'laRonde', name: 'La Ronde', path: '/la-ronde', logo: '/images/logos/logo-la-ronde.png' },
    
    // Silver Dollar City
    { id: 'silverDollarCity', name: 'Silver Dollar City', path: '/silver-dollar-city', logo: '/images/logos/logo-silver-dollar-city.png' }
  ],
  asia: [
    // Hong Kong Disneyland Park
    { id: 'hongKongDisneylandPark', name: t('parks.hongKongDisneylandPark'), path: '/hong-kong-disneyland-park', logo: '/images/logos/logo-hong-kong-disneyland-park.png' },
    
    // Lotte World
    { id: 'lotteWorld', name: t('parks.lotteWorld'), path: '/lotte-world', logo: '/images/logos/logo-lotte-world.png' },
    
    // Shanghai Disneyland
    { id: 'shanghaiDisneyland', name: t('parks.shanghaiDisneyland'), path: '/shanghai-disneyland', logo: '/images/logos/logo-shanghai-disneyland.png' },
    
    { id: 'sixFlagsQiddiyacity', name: t('parks.sixFlagsQiddiyacity'), path: '/six-flags-qiddiyacity', logo: '/images/logos/logo-sfq.png' },
    
    // Tokyo Disneyland
    { id: 'tokyoDisneyland', name: t('parks.tokyoDisneyland'), path: '/tokyo-disneyland', logo: '/images/logos/logo-tokyo-disneyland.png' },
    
    // Tokyo DisneySea
    { id: 'tokyoDisneysea', name: 'Tokyo DisneySea', path: '/tokyo-disneysea', logo: '/images/logos/logo-tokyo-disney-sea.png' },
    
    // Universal Studios Beijing
    { id: 'universalStudiosBeijing', name: t('parks.universalStudiosBeijing'), path: '/universal-studios-beijing', logo: '/images/logos/logo-universal-studios-beijing.png' },
    
    // Universal Studios Singapore
    { id: 'universalStudiosSingapore', name: 'Universal Studios Singapore', path: '/universal-studios-singapore', logo: '/images/logos/logo-universal-studios-singapore.png' }
  ]
});
